/**
 * Các trang của bản mẫu CMS mà backend CHƯA có API. Mỗi trang hiện đúng bố cục của
 * bản mẫu (bộ lọc, các cột của bảng) với dải "Chức năng chưa có API" nêu API cần
 * bổ sung; bộ lọc bị khoá, bảng rỗng — KHÔNG có dữ liệu giả.
 */
import type { ReactNode } from 'react';
import { vi } from '../ngon-ngu/vi';
import { BangChuaCoDuLieu, DaiChuaCoApi, NhanChuaCoApi, TruongLoc } from '../thanh-phan/MauGiaoDien';

export type MaTrangChuaCoApi = 'bao-cao-dong';

interface CauHinhTrang {
  tieuDe: string;
  loc: readonly string[];
  cot: readonly string[];
  canApi: readonly string[];
  /** Nút hành động của bản mẫu (bị khoá). */
  nut?: string[];
}

const t = vi.trangChuaCoApi;

const CAU_HINH: Record<MaTrangChuaCoApi, CauHinhTrang> = {
  'bao-cao-dong': {
    tieuDe: vi.menuCon.cauHinhBaoCaoDong,
    loc: [],
    cot: t.cot.baoCaoDong,
    canApi: [
      'GET/POST/PUT/DELETE /api/v1/report-types',
      'POST/DELETE /api/v1/report-types/{ma}/excel-template',
    ],
    nut: [t.nut.themMoiBaoCao],
  },
};

export function TrangChuaCoApi({ ma }: { ma: MaTrangChuaCoApi }): ReactNode {
  const c = CAU_HINH[ma];
  return (
    <section className="man-hinh" data-man-hinh={`chua-co-api-${ma}`}>
      <header className="man-hinh__dau">
        <h1>
          {c.tieuDe}
          <NhanChuaCoApi />
        </h1>
        {c.nut ? (
          <div className="man-hinh__hanh-dong">
            {c.nut.map((n) => (
              <button key={n} type="button" className="nut nut--chinh" disabled title={vi.chuaCoApi.goiY}>
                {n}
              </button>
            ))}
          </div>
        ) : null}
      </header>
      <DaiChuaCoApi canApi={c.canApi} />
      {c.loc.length > 0 ? (
        <div className="thanh-loc-mau">
          {c.loc.map((l, i) => (
            <TruongLoc key={l} nhan={l} htmlFor={`loc-${ma}-${i}`}>
              <select id={`loc-${ma}-${i}`} disabled>
                <option>{t.tatCa}</option>
              </select>
            </TruongLoc>
          ))}
        </div>
      ) : null}
      <BangChuaCoDuLieu nhan={c.tieuDe} cot={c.cot} />
    </section>
  );
}
